import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const ProductMockup = () => {
  const ref = useRef(null);
  const rawX = useMotionValue(0);
  const rawY = useMotionValue(0);
  const rotateX = useSpring(rawY, { stiffness: 120, damping: 18 });
  const rotateY = useSpring(rawX, { stiffness: 120, damping: 18 });

  const onMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    rawX.set(px * 6);
    rawY.set(-py * 6);
  };

  const onLeave = () => {
    rawX.set(0);
    rawY.set(0);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={{ rotateX, rotateY, transformPerspective: 1400 }}
      className="relative will-change-transform"
      data-testid="product-mockup"
    >
      <div className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-[0_40px_80px_-20px_rgba(10,15,29,0.35)]">
        <div className="flex items-center gap-2 border-b border-slate-100 bg-slate-50/80 px-4 py-2.5">
          <span className="h-2.5 w-2.5 rounded-full bg-rose-400" />
          <span className="h-2.5 w-2.5 rounded-full bg-amber-400" />
          <span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
          <span className="ml-3 flex-1 rounded-md border border-slate-100 bg-white px-3 py-1 font-mono-orbit text-[10px] font-medium text-slate-400">
            app.orbit.fr
          </span>
        </div>
        <img
          src="/assets/orbit-dashboard.png"
          alt="Interface Orbit — tableau de bord de pilotage réseau"
          className="block w-full"
        />
      </div>
    </motion.div>
  );
};

export default ProductMockup;
